import { useEffect, useRef } from "react";

const TelegramLoginWidget = ({
  img = null,
}) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://telegram.org/js/telegram-widget.js?22";
    script.async = true;

    containerRef.current?.appendChild(script);

    return () => {
      if (containerRef.current) {
        containerRef.current.innerHTML = "";
      }
    };
  }, []);

  const handleLogin = () => {
    window.Telegram.Login.auth({
      bot_id: process.env.REACT_APP_TELEGRAM_LOGIN_BOT_ID,
      request_access: true
    }, (data) => {
      if (!data) {
        console.error('Telegram Auth failed');
        return;
      }
      const params = new URLSearchParams(data).toString();
      window.location.href = `/?${params}`; // let Home.js and LiveCasino.js deal with telegram auth callbacks
    });
  }

  return (
      <button ref={containerRef} type="button" onClick={handleLogin}>
        <img src={img} alt="Telegram Logo"></img>
      </button>
  );
};

export default TelegramLoginWidget;
